import React from 'react';

const Footer = () => {
	const openInNewTab = (url) => {
		const newWindow = window.open(url, '_blank', 'noopener, noreferrer');
		if (newWindow) newWindow.opener = null;
	};
	return (
		<>
			<a
				href='https://wujopoznan.pl'
				target='_blank'
				rel='noopener noreferrer'
			>
				<div className='w-full absolute drop-shadow-2xl grid bg-cyan-400 h-28'>
					<img
						className='m-auto w-56'
						src={`${process.env.REACT_APP_API_DOMAIN}/images/wujo_white_logo_shadow.png`}
					/>
				</div>
			</a>

			<div className='mx-5 mt-20 grid content-end h-80 bg-gradient-to-t from-[#503854] to-[#f9b866]'>
				<img
					className='mx-auto'
					src={`${process.env.REACT_APP_API_DOMAIN}/images/footer_city_panorama_bottom.png`}
					alt='poznan-panorma'
				/>
			</div>
			<div className=' text-white bg-[#503854]'>
				<img
					className='mx-auto w-24 py-4'
					src={`${process.env.REACT_APP_API_DOMAIN}/images/poznanskirap-logo.png`}
				/>
			</div>
			<div className='text-white text-center text-xs bg-[#000000]'>
				Copyright © 2023 • Design & development by Apps Konrad Koch • NIP 9721298721
			</div>
		</>
	);
};

export default Footer;
